export enum EnumMarginType {
  PERCENTAGE = 'PERCENTAGE',
  AMOUNT = 'AMOUNT',
}
